import { Pipe, PipeTransform } from '@angular/core';

import { RangeType } from '../entities/fetch-filters.response';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { environment as ENV } from '@environment';
import { secondsToStringTime, SECONDS_IN_HOURS } from '@app/modules/flight-results/mappers/filters.mapper';
import { TimeFormatPipe } from '@app/pipes/time-format.pipe';

@Pipe({
  name: 'rangeType',
  standalone: false
})
export class RangeTypePipe implements PipeTransform {

  constructor(
    private currencyFormatPipe: CurrencyFormatPipe,
    private timeFormatPipe: TimeFormatPipe
  ) { }

  transform(value: number, type: string, isSecondsTime: boolean = false): string {
    switch (type) {
      case RangeType.PRICE:
        return this.currencyFormatPipe.transform(parseFloat(value.toString()), ENV.countryInfo.currency_code);
      case RangeType.TIME:
        return this.timeFormatPipe.transform(secondsToStringTime(value));
      case RangeType.NUMBER_TIME:
        return secondsToStringTime(isSecondsTime ? value : (parseFloat(value.toString()) * SECONDS_IN_HOURS), true);
      default:
        return this.timeFormatPipe.transform(secondsToStringTime(parseFloat(value.toString()) * SECONDS_IN_HOURS));
    }
  }
}
